export const LIST = "ANGPAU_LUCKY_DRAW_SETTING_LIST";
export const DROPDOWN = "ANGPAU_LUCKY_DRAW_SETTING_DROPDOWN";
export const STORE = "ANGPAU_LUCKY_DRAW_SETTING_STORE";
export const UPDATE = "ANGPAU_LUCKY_DRAW_SETTING_UPDATE";
export const DELETE = "ANGPAU_LUCKY_DRAW_SETTING_DELETE";
export const UPDATE_STATUS = "ANGPAU_LUCKY_DRAW_SETTING_UPDATE_STATUS";
export const DETAILS = "ANGPAU_LUCKY_DRAW_SETTING_DETAILS";